import { Injectable } from '@angular/core';
import { catchError, retry } from 'rxjs/internal/operators';
import { Observable, throwError } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { DeviceService } from './device.service';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { RuntimeConfigLoaderService } from 'runtime-config-loader';
import { GlobalSearchService } from '../services/globalsearchservice.service';
@Injectable({
	providedIn: 'root'
})

export class CouponService {
	key = 'UET6DFMPAXW7BKCB';
	config: any;
	user: any = [];
	package: any = '';

	constructor(private http: HttpClient, private _configSvc: RuntimeConfigLoaderService, public globalSearchService: GlobalSearchService, private deviceService: DeviceService) {
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
			this.updateHeaders();
		})

		this.globalSearchService.user.subscribe((result) => {
			this.user = result;
			this.updateHeaders();
		});

		this.updateHeaders();
	}

	public httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json',
			'responseType': 'text'
		})
	};

	public httpOptions2 = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json',
		})
	};

	private updateHeaders() {
		const uuid = this.deviceService.getDeviceUUID();
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		if (this.config && this.config.apiCredentials && this.config.apiCredentials.clientId && this.user && this.user.user && this.user.user.userid) {
			headers = headers.set('Authorization', 'Bearer ' + this.config.apiCredentials.clientId + '_' + this.user.user.userid);
		}
		headers = headers.set('X-Device-UUID', uuid);
		this.httpOptions.headers = headers;
		this.httpOptions2.headers = headers;
		this.getOptions.headers = headers;
	}



	public getOptions = {
		headers: new HttpHeaders({

		})
	};

	public addCoupon(coupon: Object = {}) {
		const method = 'marketing/coupon/add' + this.getApiKey();


		return this.http.post(this.setEndPoint(method), (JSON.stringify(coupon)))
			.pipe(catchError(this.handleError(method, coupon)))
	}

	public editCoupon(coupon: Object = {}) {
		const method = 'marketing/coupon/edit' + this.getApiKey();

		return this.http.post(this.setEndPoint(method), (JSON.stringify(coupon)))
			.pipe(catchError(this.handleError(method, coupon)))
	}

	public deleteCoupon(coupon: Object = {}) {
		const method = 'marketing/coupon/delete' + this.getApiKey();

		return this.http.post(this.setEndPoint(method), JSON.stringify(coupon))
			.pipe(catchError(this.handleError(method, coupon)));
	}

	public getAllCoupons() {
		const method = 'marketing/coupon/getAllCoupons' + this.getApiKey();

		return this.http.get(this.setEndPoint(method))
	}


	public applyCoupon(data:any){
		const method = 'marketing/coupon/applycoupon';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions2).pipe(
			catchError(this.handleError('coupon', data))
		);
	}
	public unapplyCoupon(data:any){
		const method = 'marketing/coupon/unapplycoupon';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions2).pipe(
			catchError(this.handleError('coupon', data))
		);
	}
	public checkForCoupon(data:any){
		const method = 'marketing/coupon/checkfor';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions2).pipe(
			catchError(this.handleError('coupon', data))
		);
	}
	public getCartCouponValue(data: any){
		const method = 'cart/coupontotal';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions2).pipe(
			catchError(this.handleError('coupon', data))
		);
	}

	public depleteCoupon(data:any){
		const method = 'marketing/coupon/depletecoupon';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions2).pipe(
			catchError(this.handleError('coupon', data))
		);
	}

	public checkCouponAvailability(data:any){
		const method = 'marketing/coupon/checkcouponavailability';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions2).pipe(
			catchError(this.handleError('coupon', data))
		);
	}

	public getCouponData(data:any){
		const method = 'marketing/coupon/getcoupondata';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions2).pipe(
			catchError(this.handleError('coupon', data))
		);
	}

	public removeCouponHistory(data:any){
		const method = 'marketing/coupon/removeordercouponhistory';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions2).pipe(
			catchError(this.handleError('coupon', data))
		);
	}

	public revalidateCoupon(data: any){
		const method = 'marketing/coupon/validatecoupon';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions2).pipe(
			catchError(this.handleError('coupon', data))
		);
	}

	public recalculateCoupons(data: any){
		const method = 'marketing/coupon/recalculatecoupon';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions2).pipe(
			catchError(this.handleError('coupon', data))
		);
	}

	private setEndPoint(method: any) {
		return this.getApi() + method + this.getApiKey()
	}

	private getApi() {
		return this.config.apiServer.endpoint;
	}

	private getApiKey() {
		return '&key=' + this.config.apiCredentials.clientId + '&userid=' + this.user.user.userid + this.getPackage();
	}

	private getPackage() {
		const p = this.globalSearchService.getSessionItem('package');
		if(p) {
			return '&package='+p;
		} else {
			return '';
		}
	}

	public getKey() {
		return '&apikey=' + this.key;
	}

	private handleError<T>(operation = 'operation', result?: T) {

		return (error: any): Observable<T> => {

			if (error instanceof HttpErrorResponse && error.status === 401) {
				window.location.href = '/#/auth/logout';
			}

			return throwError(() => error);
		};
	}
}
